module.exports = __webpack_public_path__ + "static/level-4-logo.890feab3.png";